import { Brain, Code2, LucideIcon, RefreshCw } from "lucide-react"

export const apiMarketingFeatures = [
  { icon: Brain, title: "AI-Ready Data", description: "Optimized for LLMs" },
  {
    icon: RefreshCw,
    title: "Real-time Sync",
    description: "Low-latency webhooks"
  },
  { icon: Code2, title: "Dev-First SDKs", description: "Python, Node.js, Go" }
]

interface FeatureCardProps {
  icon: LucideIcon
  title: string
  description: string
}

export const ApiMarketingFeatureCard = ({
  icon: Icon,
  title,
  description
}: FeatureCardProps) => (
  <div className="bg-white rounded-2xl border border-neutral-200 p-8 text-center shadow-sm hover:shadow-md transition-shadow">
    <div className="w-14 h-14 rounded-full bg-primary-50 flex items-center justify-center mb-4 mx-auto">
      <Icon size={24} className="text-primary-600" />
    </div>
    <h3 className="text-xl font-serif font-semibold text-primary-900 mb-2">
      {title}
    </h3>
    <p className="text-sm text-neutral-500">{description}</p>
  </div>
)
